module.exports = __webpack_public_path__ + "static/media/021-smartphone-2.1b52a5aa.svg";